import React from 'react';
import PropTypes from 'prop-types';

import SocialMediaConnectionShape from 'app/shapes/SocialMediaConnectionShape';

import { capitalize } from 'app/helpers/stringHelpers';

import {
  Box,
  Button,
  FormControl,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
  styled,
} from '@mui/material';

import { red } from '@mui/material/colors';

import UnlinkSocialMediaConnection from 'app/components/social_shouts/UnlinkSocialMediaConnection';
import IconSocialBluesky from 'app/components/customSvgs/IconSocialBluesky';

const SmallTextField = styled(TextField)(() => ({
  '& .MuiInputBase-root': {
    height: '42px !important',
    minHeight: '42px !important',
  },
  '& .MuiOutlinedInput-input': {
    padding: '8px 10px !important',
    fontSize: '0.875em !important',
  },
}));

const BlueskySetupCard = ({ connection, handleChanged, setupConnection }) => {
  return (
    <Paper sx={{ p: 2 }} elevation={0}>
      <Grid container alignItems="center">
        <Grid item xs={8}>
          <Stack direction="row" spacing={2} alignItems="center">
            <Box>
              <IconSocialBluesky alt="Bluesky" style={{ height: '32px', width: '32px' }} />
            </Box>
            <Box>
              <Typography>
                Bluesky
              </Typography>
              {connection?.username && (
                <Typography variant="body1">
                  <a href={`https://${connection.username}/`}>{connection.username}</a>
                </Typography>
              )}
              {connection?.authentication_error && (
                <Typography variant="body2" sx={{ color: red[600], fontSize: '0.875em', mt: 0.4 }}>
                  We’re sorry, this account is not working. Please try to link the account later.
                </Typography>
              )}
            </Box>
          </Stack>
        </Grid>
        <Grid item xs={4} className="pull-right">
          { (connection?.id && !connection?.authentication_error && (
            <UnlinkSocialMediaConnection connection={connection} />
          )) || (
            <FormControl>
              <SmallTextField name="handle" size="small" onChange={handleChanged} placeholder="username.bsky.social" />
              <Button variant="outlined" size="small" onClick={setupConnection} sx={{ mt: 1 }}>
                { connection?.authentication_error ? 'Link' : `Setup ${capitalize(connection.provider)}` }
              </Button>
            </FormControl>
          )}
        </Grid>
      </Grid>
    </Paper>
  );
};

BlueskySetupCard.defaultProps = {
  connection: null,
};

BlueskySetupCard.propTypes = {
  connection: SocialMediaConnectionShape,
  handleChanged: PropTypes.func.isRequired,
  setupConnection: PropTypes.func.isRequired,
};

export default BlueskySetupCard;
